import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center text-muted-foreground">
                Chargement…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
